module.exports = __webpack_public_path__ + "static/media/ins4.5c893d08.jpg";